import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-connection-status',
  templateUrl: './connection-status.component.html',
  styleUrls: ['./connection-status.component.scss'],
  imports: [CommonModule, MatIconModule],
  standalone: true,
})
export class ConnectionStatusComponent {
  @Input() status: number;

  @Input() endDate: any | null;

  constructor() {}

  get fullEndDate(): Date | null {
    if (this.endDate == null) {
      return null;
    }
    let localDate = this.endDate.LocalDate;

    if (localDate == null) {
      localDate = this.endDate;
    }
    if (typeof localDate === 'string' || localDate instanceof Date) {
      return new Date(localDate);
    }
    if (typeof localDate === 'object' && localDate.year != null && localDate.month != null && localDate.day != null) {
      return new Date(localDate.year, localDate.month - 1, localDate.day);
    }

    return null;
  }

  get statusLabel(): string {
    switch (this.status) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 5:
      case 4:
        return 'Actief';
      case 6:
        return 'Archived';
      case 7:
        return 'Interne overname - onterechte switch';
      case 8:
        return 'Geannuleerd';
      default:
        return 'Onbekende status';
    }
  }
}
